export enum CookieEnum {
  SELECTED_LOCALE = "selectedLocale",
  SELECTED_ORGANISATION = "selectedOrganisation",
}
